import { render } from "./myPraise.vue?vue&type=template&id=5a922bed&scoped=true"
import script from "./myPraise.vue?vue&type=script&lang=js"
export * from "./myPraise.vue?vue&type=script&lang=js"

import "./myPraise.vue?vue&type=style&index=0&id=5a922bed&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a922bed"]])

export default __exports__